export default __webpack_public_path__ + "static/media/arrow_right.2a2c9a07.svg";